$(document).ready(function (){

	new window.Swiper('.ce__teaserwall--slider', {
		slidesPerView: 1,
		autoplay: false,
		cssWidthAndHeight: true,
		autoHeight: true,
		spaceBetween: 20,
		a11y: {
			prevSlideMessage: 'Vorheriges Element',
			nextSlideMessage: 'Nächstes Element',
		},
		// loop: true,
		pagination: {
			el: '.ce__teaserwall--slider .swiper-pagination',
			dynamicBullets: true,
			dynamicMainBullets: 3,
			clickable: true
		},
		navigation: {
			nextEl: '.ce__teaserwall--slider .swiper-news-next',
			prevEl: '.ce__teaserwall--slider .swiper-news-prev',
		},
		breakpoints: {
			768: {
				autoHeight: false,
				slidesPerView: 'auto'
			}
		}
    });
});
